let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gRAp9")).then(() => parcelRequire('dqKlG'));